import * as jsxRuntime from "/builds/smartsuite/data-import-export/oneschema-import-ui/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment